import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import controller from "../../../../Resources/Scripts/_Shared/Controller";
import { InputWithLabel } from '../../../../Resources/Scripts/_Shared/elements/InputWithLabel';
import { permits } from './Endpoints';

function myAimoParkPermitsEditPoNumber(context) {
  const appContainer = context;
  const appConfig = controller.getConfig(context);

  const App = () => {
    const ticket = appConfig.permit;
    const lang = appConfig.localization;
    const [isBeingEdited, setIsBeingEdited] = useState(false);
    const [isPending, setIsPending] = useState(false);
    const [currentPoNumber, setCurrentPoNumber] = useState(ticket.poNumber);
    const [newPoNumber, setNewPoNumber] = useState(ticket.poNumber);
    const [error, setError] = useState("");

    const clearError = () => {
      if (error !== "") {
        setError("");
      }
    }

    const handlePoNumberChange = (newValue) => {
      if (newValue === undefined || newValue === null || (newValue.text !== undefined && newValue.text === null)) {
        return;
      }

      setNewPoNumber(newValue.text !== undefined ? newValue.text : newValue);
      clearError();
    }

    const handleToggleIsBeingEdited = () => {
      setIsBeingEdited(!isBeingEdited);
    }

    const handleOnConfirm = async () => {
      setIsPending(true);
      const params = {
        orderId: ticket.orderId,
        orderLineIdAndVersion: ticket.orderLineIdAndVersion,
        permitId: ticket.id,
        data: {
          poNumber: newPoNumber
        }
      }
      const response = await permits.updatePermit(params);

      if (response.status === 200) {
        setIsPending(false);
        setCurrentPoNumber(newPoNumber);
        setIsBeingEdited(false);
      } else {
        setIsPending(false);
        if (response.body?.ErrorMessage) setError(response.body.ErrorMessage);
        else setError("Error " + response.status + ": " + response.info);
      }
    }

    const handleOnCancel = () => {
      setNewPoNumber(currentPoNumber);
      clearError();
      handleToggleIsBeingEdited();
    }

    if (!isBeingEdited) {
      return (
        <>
          <div className="left">{lang.poNumber}</div>
          <div className="right">
            <span>
              {currentPoNumber}
              <a href="#" 
                className="myaimoparkoverlay__overlay__list__link" 
                onClick={() => handleToggleIsBeingEdited()}
              >
                {lang.edit}
              </a>
            </span>
          </div>
        </>
      );
    } else {
      return (
        <>
          <div className="edit-po-number-external-wrapper">
            <div className="edit-po-number-wrapper">
              <div className="myaimoparkpermits__overlay__input">
                <InputWithLabel
                  maxLength={45} 
                  inputType="text"
                  text={lang.poNumber}
                  setValue={handlePoNumberChange}
                  defaultText={currentPoNumber}
                />
              </div>
              <div className="myaimoparkoverlay-button-wrapper">
                <div className="myaimoparkoverlay__overlay__bottom__inner__button myaimoparkoverlay__overlay__bottom__inner__button--cancel">
                  <button 
                    disabled={isPending} 
                    aria-busy={isPending} 
                    onClick={() => handleOnCancel()}
                  >
                    {lang.cancel}
                  </button>
                </div>
                <div className="myaimoparkoverlay__overlay__bottom__inner__button myaimoparkoverlay__overlay__bottom__inner__button--confirm">
                  <button
                    data-map-button="confirm-po-number"
                    disabled={isPending} 
                    aria-busy={isPending} 
                    onClick={() => handleOnConfirm()}
                  >
                    {lang.confirm}
                  </button>
                </div>
              </div>
            </div>
            {error !== "" && 
              <div className="myaimoparkoverlay__overlay__bottom__inner__error">
                <p dangerouslySetInnerHTML={{ __html: error }} />
              </div>
            }
          </div>
        </>
      );
    }
  };

  function init() {
    ReactDOM.render(<App />, appContainer);
  }

  return {
    init
  };
}

controller.add('myaimopark-permits-po-number', myAimoParkPermitsEditPoNumber);